import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-6 offset-md-3" }
const _hoisted_2 = { class: "login-form mt-4 p-4" }
const _hoisted_3 = { class: "row g-3" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12 error-placeholder" }

import { ref, watch, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageEmpty, type WebSocketMessageError } from "@/plugins/ws";
import ErrorLabel from "@/components/ui/ErrorLabel.vue";

import {RootState} from "@/store";

type RestoreSetPasswordMessage = WebSocketMessageEmpty<'auth-restore-set-password'>;
type RestoreSetPasswordFailMessage = WebSocketMessageError<'auth-restore-set-password-fail'>;

// Объединенный тип для всех сообщений
type RestoreConfirmWebSocketMessageType = RestoreSetPasswordMessage | RestoreSetPasswordFailMessage;


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ComponentsAuthRestoreConfirm',
},
  __name: 'RestoreConfirm',
  emits: ["switchMode"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const store = useStore<RootState>();

// Типы для WebSocket сообщений компонента RestoreConfirm
const internalInstance = getCurrentInstance();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const wsSend = internalInstance?.appContext.config.globalProperties.$wsSend as (signal: string, payload: any) => void;

const password = ref('');
const latestMessageValue = ref(latestMessage);

const setErrorReason = (reason: string) => store.dispatch('errorLabel/setErrorReason', reason);
const unsetErrorReason = () => store.dispatch('errorLabel/unsetErrorReason');

// WebSocket message handler
const handleWebSocketMessage = (data: RestoreConfirmWebSocketMessageType): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'auth-restore-set-password':
      signalRestoreSetPassword();
      break;
    case 'auth-restore-set-password-fail':
      signalRestoreSetPasswordFail(data.reason);
      break;
  }
};

watch(latestMessageValue, handleWebSocketMessage);

const handleClickActionRestoreSetPassword = () => {
  wsSend('authRestoreSetPassword', {
    newPassword: password.value,
  });
};

const signalRestoreSetPasswordFail = (payload: string) => {
  setErrorReason(payload);
};

const signalRestoreSetPassword = () => {
  unsetErrorReason();
  store.dispatch('auth/restoreSuccess');
  emit('switchMode', 'restoreSuccess');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h4", null, "Задайте новый пароль", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", null, "Вы подтвердили, что вы являетесь владельцем этого аккаунта.", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("label", null, "Новый пароль", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            name: "password",
            class: "form-control",
            placeholder: "New password",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event))
          }, null, 512), [
            [_vModelText, password.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ErrorLabel)
        ]),
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-dark float-end ms-3",
            onClick: handleClickActionRestoreSetPassword
          }, "Продолжить")
        ])
      ])
    ])
  ]))
}
}

})